import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { TRANSLATIONS, HINDI_STATES } from "@/lib/i18n";

const Ctx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("bb_lang") || "en");

  useEffect(() => {
    localStorage.setItem("bb_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLangByState = useCallback((state) => {
    if (localStorage.getItem("bb_lang_manual") === "1") return;
    if (state && HINDI_STATES.has(state.toLowerCase().trim())) setLang("hi");
    else setLang("en");
  }, []);

  const t = useMemo(() => TRANSLATIONS[lang] || TRANSLATIONS.en, [lang]);

  const toggle = useCallback(() => {
    localStorage.setItem("bb_lang_manual", "1");
    setLang((l) => (l === "en" ? "hi" : "en"));
  }, []);

  return (
    <Ctx.Provider value={{ lang, setLang, toggle, t, setLangByState }}>
      {children}
    </Ctx.Provider>
  );
}

export const useLang = () => {
  const c = useContext(Ctx);
  if (!c) throw new Error("useLang must be used within LanguageProvider");
  return c;
};
